var map = {
	"./adminRoutes.js": "a69b",
	"./appContentRoutes.js": "9456",
	"./attendanceRoutes.js": "8c56",
	"./dashboardRoutes.js": "41af",
	"./mainRoutes.js": "0690",
	"./routes.js": "79c7",
	"./studentsRoutes.js": "12c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7191";